import React, { useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import "./index.css";

import PatrimonyMapMenuPositionsItem from "./../PatrimonyMapMenuPositionsItem";

import { sortPositions } from "./../../utils/Position";

const PatrimonyMapMenuPositions = ({
  options,
  props: {
    currentUser,
    routes
  }
}) => {
  const {
    routeId: __routeId = "",
  } = options;

  const [routeId] = useState(__routeId);

  const getRoute = () => {
    const route = routes.find(x => x.id === routeId);
    if(route) {
      return route;
    }
    return false;
  };

  const getRoutePositions = () => {
    const simulatorRoute = getRoute();
    if(simulatorRoute) {
      const positions = JSON.parse(JSON.stringify(simulatorRoute.routePositions));
      return sortPositions(positions.filter(x => x.id !== "sp-cursor"));
    }
    return [];
  };

  return (
    <ul className="patrimony-map-menu-positions">
      {
        getRoutePositions().map(routePosition => (
          <PatrimonyMapMenuPositionsItem key={`rp-${routePosition.id}`} options={{...routePosition, onClick: () => {
            // removeSingleRoute();
            // removeSingleTranshipment();
            // selectLastPosition(lastPosition.id);
          }}} />
        ))
      }
    </ul>
  );
};

const mapStateToProps = state => ({
  props: {
    currentUser: state.users.currentUser,
    routes: state.simulatorsMaps.routes
  }
});

const mapDispatchToProps = dispatch => ({
  funcs: bindActionCreators(Object.assign({}), dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(PatrimonyMapMenuPositions);
